module.exports = __webpack_public_path__ + "static/images/b-week.127eaaa.png";